import {
  DEMO_ACADEMY_NORTH_ID,
  DEMO_ACADEMY_SOUTH_ID,
  DEMO_GROUP_U13B,
  DEMO_GROUP_U14W,
  DEMO_GROUP_U15A,
  DEMO_GROUP_U17,
} from "./mockFilterHelpers";
import { DEMO_ACADEMY_ID, mockPlayers } from "./mockPlayers";
import { demoApi } from "./demoLocale";

type MonitoringRequest = {
  AcademyId?: string;
  GroupId?: string | number | null;
  Microcycle?: number;
  Activity?: number;
  Levels?: number[];
  WeekNumbers?: number[];
  Year?: number;
};

type PlayerStatsRecord = Record<string, number | string | null>;

type MonitoringPlayerSeed = {
  playerId: string;
  firstName: string;
  lastName: string;
  group: string;
  groupId: string;
  academyId: string;
  academyName: string;
  preferredPosition: number;
  phv: number;
  birthYear: number;
  form: number;
  readiness: number;
  potential: number;
  stats: PlayerStatsRecord;
  trendFactor?: number;
};

const DEMO_GROUP_MLODZIK = "00000000-0000-0000-0000-000000001801";

const monitoringFoldersByAcademy: Record<string, { FolderId: string; Name: string }[]> = {
  [DEMO_ACADEMY_ID]: [
    { FolderId: DEMO_GROUP_U15A, Name: "Pierwsza drużyna" },
    { FolderId: DEMO_GROUP_U13B, Name: "Rezerwy" },
    { FolderId: DEMO_GROUP_U17, Name: "U17" },
  ],
  [DEMO_ACADEMY_NORTH_ID]: [{ FolderId: DEMO_GROUP_U14W, Name: "Trampkarz 2014" }],
  [DEMO_ACADEMY_SOUTH_ID]: [{ FolderId: DEMO_GROUP_MLODZIK, Name: "Młodzik 2013" }],
};

const monitoringPlayerSeeds: MonitoringPlayerSeed[] = [
  {
    playerId: mockPlayers[0].PlayerId,
    firstName: "Jan",
    lastName: "Kowalski",
    group: "Pierwsza drużyna",
    groupId: DEMO_GROUP_U15A,
    academyId: DEMO_ACADEMY_ID,
    academyName: "Klub piłkarski",
    preferredPosition: 3,
    phv: 1.18,
    birthYear: 2010,
    form: 74,
    readiness: 82,
    potential: 79,
    trendFactor: 0.92,
    stats: {
      EventCountNLastDays: 5,
      EventTotalTimeInMinutes: 375,
      MaxSpeedNLastDays: "28.40",
      TotalDistance: 6200,
      AverageDistance: 6200,
      RunDistanceTotal: 3350,
      RunDistancePercentage: "54.03",
      HSRDistanceTotal: 1260,
      HSRDistancePercentage: "20.32",
      SprintDistanceTotal: 525,
      SprintDistancePercentage: "8.47",
      SprintNumberTotal: 46,
      TimeToSprintInSeconds: "18.20",
      HMLDDistance: 970,
      HMLDDistancePercentage: "15.65",
      AccelerationNumberTotal: 118,
      DecelerationNumberTotal: 109,
      MaxPowerOutput: "845.00",
      MaxHeartRate: 186,
      HeartRateLastNDaysAvg: 148,
      HeartRate1ZonePercentage: 11,
      HeartRate2ZonePercentage: 19,
      HeartRate3ZonePercentage: 34,
      HeartRate4ZonePercentage: 24,
      HeartRate5ZonePercentage: 12,
      HRR: 128,
      DynamicPercentage: 71,
      EnergyPercentage: 68,
      EndurancePercentage: 64,
      IntensityPercentage: 72,
      BurnCalories: 2860,
      Load: 6.4,
    },
  },
  {
    playerId: mockPlayers[1].PlayerId,
    firstName: "Adam",
    lastName: "Nowak",
    group: "Rezerwy",
    groupId: DEMO_GROUP_U13B,
    academyId: DEMO_ACADEMY_ID,
    academyName: "Klub piłkarski",
    preferredPosition: 4,
    phv: 0.92,
    birthYear: 2012,
    form: 81,
    readiness: 88,
    potential: 86,
    trendFactor: 0.88,
    stats: {
      EventCountNLastDays: 4,
      EventTotalTimeInMinutes: 300,
      MaxSpeedNLastDays: "31.80",
      TotalDistance: 5800,
      AverageDistance: 5800,
      RunDistanceTotal: 2320,
      RunDistancePercentage: "40.00",
      HSRDistanceTotal: 2010,
      HSRDistancePercentage: "34.66",
      SprintDistanceTotal: 1590,
      SprintDistancePercentage: "27.41",
      SprintNumberTotal: 72,
      TimeToSprintInSeconds: "12.40",
      HMLDDistance: 1650,
      HMLDDistancePercentage: "28.45",
      AccelerationNumberTotal: 164,
      DecelerationNumberTotal: 121,
      MaxPowerOutput: "972.00",
      MaxHeartRate: 194,
      HeartRateLastNDaysAvg: 156,
      HeartRate1ZonePercentage: 8,
      HeartRate2ZonePercentage: 14,
      HeartRate3ZonePercentage: 28,
      HeartRate4ZonePercentage: 31,
      HeartRate5ZonePercentage: 19,
      HRR: 136,
      DynamicPercentage: 84,
      EnergyPercentage: 79,
      EndurancePercentage: 58,
      IntensityPercentage: 81,
      BurnCalories: 2480,
      Load: 7.8,
    },
  },
  {
    playerId: mockPlayers[2].PlayerId,
    firstName: "Piotr",
    lastName: "Wiśniewski",
    group: "U17",
    groupId: DEMO_GROUP_U17,
    academyId: DEMO_ACADEMY_ID,
    academyName: "Klub piłkarski",
    preferredPosition: 3,
    phv: 1.42,
    birthYear: 2008,
    form: 69,
    readiness: 76,
    potential: 81,
    trendFactor: 0.95,
    stats: {
      EventCountNLastDays: 6,
      EventTotalTimeInMinutes: 450,
      MaxSpeedNLastDays: "27.10",
      TotalDistance: 6900,
      AverageDistance: 6900,
      RunDistanceTotal: 4620,
      RunDistancePercentage: "66.96",
      HSRDistanceTotal: 1230,
      HSRDistancePercentage: "17.83",
      SprintDistanceTotal: 575,
      SprintDistancePercentage: "8.33",
      SprintNumberTotal: 38,
      TimeToSprintInSeconds: "20.80",
      HMLDDistance: 990,
      HMLDDistancePercentage: "14.35",
      AccelerationNumberTotal: 96,
      DecelerationNumberTotal: 88,
      MaxPowerOutput: "798.00",
      MaxHeartRate: 182,
      HeartRateLastNDaysAvg: 151,
      HeartRate1ZonePercentage: 13,
      HeartRate2ZonePercentage: 22,
      HeartRate3ZonePercentage: 36,
      HeartRate4ZonePercentage: 20,
      HeartRate5ZonePercentage: 9,
      HRR: 131,
      DynamicPercentage: 66,
      EnergyPercentage: 71,
      EndurancePercentage: 78,
      IntensityPercentage: 69,
      BurnCalories: 3320,
      Load: 8.2,
    },
  },
  {
    playerId: mockPlayers[3].PlayerId,
    firstName: "Kacper",
    lastName: "Malinowski",
    group: "Trampkarz 2014",
    groupId: DEMO_GROUP_U14W,
    academyId: DEMO_ACADEMY_NORTH_ID,
    academyName: "Oddział Akademii",
    preferredPosition: 2,
    phv: 1.05,
    birthYear: 2011,
    form: 77,
    readiness: 80,
    potential: 74,
    trendFactor: 0.9,
    stats: {
      EventCountNLastDays: 4,
      EventTotalTimeInMinutes: 320,
      MaxSpeedNLastDays: "26.60",
      TotalDistance: 6400,
      AverageDistance: 6400,
      RunDistanceTotal: 3240,
      RunDistancePercentage: "50.63",
      HSRDistanceTotal: 1225,
      HSRDistancePercentage: "19.14",
      SprintDistanceTotal: 455,
      SprintDistancePercentage: "7.11",
      SprintNumberTotal: 34,
      TimeToSprintInSeconds: "19.60",
      HMLDDistance: 870,
      HMLDDistancePercentage: "13.59",
      AccelerationNumberTotal: 142,
      DecelerationNumberTotal: 151,
      MaxPowerOutput: "812.00",
      MaxHeartRate: 178,
      HeartRateLastNDaysAvg: 144,
      HeartRate1ZonePercentage: 12,
      HeartRate2ZonePercentage: 20,
      HeartRate3ZonePercentage: 33,
      HeartRate4ZonePercentage: 23,
      HeartRate5ZonePercentage: 12,
      HRR: 122,
      DynamicPercentage: 76,
      EnergyPercentage: 65,
      EndurancePercentage: 61,
      IntensityPercentage: 70,
      BurnCalories: 2240,
      Load: 6.1,
    },
  },
  {
    playerId: mockPlayers[4].PlayerId,
    firstName: "Bartosz",
    lastName: "Krawczyk",
    group: "Młodzik 2013",
    groupId: DEMO_GROUP_MLODZIK,
    academyId: DEMO_ACADEMY_SOUTH_ID,
    academyName: "Oddział Akademii - Zachodni",
    preferredPosition: 1,
    phv: 1.28,
    birthYear: 2010,
    form: 63,
    readiness: 71,
    potential: 68,
    trendFactor: 0.97,
    stats: {
      EventCountNLastDays: 3,
      EventTotalTimeInMinutes: 210,
      MaxSpeedNLastDays: "18.20",
      TotalDistance: 5200,
      AverageDistance: 5200,
      RunDistanceTotal: 1340,
      RunDistancePercentage: "25.77",
      HSRDistanceTotal: 200,
      HSRDistancePercentage: "3.85",
      SprintDistanceTotal: 75,
      SprintDistancePercentage: "1.44",
      SprintNumberTotal: 6,
      TimeToSprintInSeconds: "31.40",
      HMLDDistance: 135,
      HMLDDistancePercentage: "2.60",
      AccelerationNumberTotal: 28,
      DecelerationNumberTotal: 24,
      MaxPowerOutput: "410.00",
      MaxHeartRate: 162,
      HeartRateLastNDaysAvg: 128,
      HeartRate1ZonePercentage: 24,
      HeartRate2ZonePercentage: 28,
      HeartRate3ZonePercentage: 22,
      HeartRate4ZonePercentage: 16,
      HeartRate5ZonePercentage: 10,
      HRR: 104,
      DynamicPercentage: 42,
      EnergyPercentage: 48,
      EndurancePercentage: 55,
      IntensityPercentage: 44,
      BurnCalories: 980,
      Load: 3.2,
    },
  },
];

const parseNumber = (value: unknown): number => {
  if (typeof value === "number") {
    return Number.isFinite(value) ? value : 0;
  }
  if (typeof value === "string") {
    const parsed = Number(value.replace(",", "."));
    return Number.isFinite(parsed) ? parsed : 0;
  }
  return 0;
};

const formatDecimal = (value: number, digits = 2): string => value.toFixed(digits);

const ALL_ACTIVITY_LEVELS = [0, 1, 2];

const getMicrocycleScales = (microcycle: number, weekNumbers: number[] = []) => {
  switch (microcycle) {
    case 0:
      return { current: 1, previous: 0.84 };
    case 1:
      return { current: 0.84, previous: 0.72 };
    case 3:
      return { current: 2.55, previous: 2.15 };
    case 5:
      return { current: 1, previous: 0.84 };
    case 8:
      return { current: 6.8, previous: 5.9 };
    case 7: {
      if (!weekNumbers.length) {
        return { current: 0, previous: 0 };
      }
      const weekFactor = weekNumbers.reduce((sum, week) => sum + 0.22 + week * 0.04, 0);
      const current = Math.min(1.35, weekFactor / weekNumbers.length);
      return { current, previous: current * 0.88 };
    }
    case 4:
    default:
      return { current: 0.93, previous: 0.8 };
  }
};

const getLevelsFactor = (levels?: number[]) => {
  const selected = Array.isArray(levels) && levels.length ? levels : ALL_ACTIVITY_LEVELS;
  if (selected.length >= 3) {
    return 1;
  }
  if (selected.length === 2) {
    return 0.9;
  }
  return 0.74;
};

const applyActivityModifiers = (stats: PlayerStatsRecord, activity = 5): PlayerStatsRecord => {
  const next = { ...stats };

  if (activity === 0) {
    next.SprintDistanceTotal = Number((parseNumber(next.SprintDistanceTotal) * 0.62).toFixed(0));
    next.HSRDistanceTotal = Number((parseNumber(next.HSRDistanceTotal) * 0.68).toFixed(0));
    next.SprintNumberTotal = Number((parseNumber(next.SprintNumberTotal) * 0.58).toFixed(0));
    next.TotalDistance = Number((parseNumber(next.TotalDistance) * 1.08).toFixed(0));
    next.RunDistanceTotal = Number((parseNumber(next.RunDistanceTotal) * 1.12).toFixed(0));
    next.IntensityPercentage = Number((parseNumber(next.IntensityPercentage) * 0.92).toFixed(0));
    next.Load = Number((parseNumber(next.Load) * 0.88).toFixed(1));
    return next;
  }

  if (activity === 4) {
    next.SprintDistanceTotal = Number((parseNumber(next.SprintDistanceTotal) * 1.48).toFixed(0));
    next.HSRDistanceTotal = Number((parseNumber(next.HSRDistanceTotal) * 1.32).toFixed(0));
    next.SprintNumberTotal = Number((parseNumber(next.SprintNumberTotal) * 1.55).toFixed(0));
    next.TotalDistance = Number((parseNumber(next.TotalDistance) * 0.8).toFixed(0));
    next.EventCountNLastDays = Number((parseNumber(next.EventCountNLastDays) * 0.72).toFixed(0));
    next.IntensityPercentage = Number((parseNumber(next.IntensityPercentage) * 1.14).toFixed(0));
    next.Load = Number((parseNumber(next.Load) * 1.18).toFixed(1));
    return next;
  }

  return next;
};

const scaleStats = (stats: PlayerStatsRecord, factor: number): PlayerStatsRecord => {
  if (factor <= 0) {
    return Object.keys(stats).reduce<PlayerStatsRecord>((acc, key) => {
      const value = stats[key];
      acc[key] = typeof value === "number" ? 0 : typeof value === "string" ? "0.00" : value;
      return acc;
    }, {});
  }

  const scaled: PlayerStatsRecord = {};
  Object.entries(stats).forEach(([key, value]) => {
    if (typeof value === "string" && key.includes("Percentage")) {
      scaled[key] = formatDecimal(parseNumber(value) * factor, 2);
      return;
    }
    if (
      typeof value === "string" &&
      (key.includes("Speed") || key.includes("Power") || key.includes("Time"))
    ) {
      scaled[key] = formatDecimal(parseNumber(value) * factor, 2);
      return;
    }
    if (typeof value === "number") {
      scaled[key] = Number(
        (value * factor).toFixed(key === "BurnCalories" || key === "Load" ? 1 : 0)
      );
      return;
    }
    scaled[key] = value;
  });
  return scaled;
};

const scaleCondition = (value: number, factor: number) =>
  Math.max(0, Math.min(100, Math.round(value * factor)));

const buildPlayerStatistics = (
  seed: MonitoringPlayerSeed,
  stats: PlayerStatsRecord,
  conditionFactor = 1
) => ({
  PlayerId: seed.playerId,
  Group: seed.group,
  Academy: {
    Id: seed.academyId,
    Name: seed.academyName,
  },
  FirstName: seed.firstName,
  LastName: seed.lastName,
  PreferredPosition: seed.preferredPosition,
  Age: new Date().getFullYear() - seed.birthYear,
  PHV: seed.phv,
  Form: scaleCondition(seed.form, conditionFactor),
  Readiness: scaleCondition(seed.readiness, conditionFactor),
  Potential: scaleCondition(seed.potential, conditionFactor),
  ...stats,
});

const buildTrendEntry = (seed: MonitoringPlayerSeed, stats: PlayerStatsRecord, factor: number) => ({
  PlayerId: seed.playerId,
  Group: seed.group,
  Academy: {
    Id: seed.academyId,
    Name: seed.academyName,
  },
  FirstName: seed.firstName,
  LastName: seed.lastName,
  PreferredPosition: seed.preferredPosition,
  Age: new Date().getFullYear() - seed.birthYear,
  PHV: seed.phv,
  Form: scaleCondition(seed.form, factor),
  Readiness: scaleCondition(seed.readiness, factor),
  Potential: scaleCondition(seed.potential, factor),
  EnergyPercentage: parseNumber(stats.EnergyPercentage),
  IntensityPercentage: parseNumber(stats.IntensityPercentage),
  ...stats,
});

const averageField = (
  players: ReturnType<typeof buildPlayerStatistics>[],
  key: string,
  asString = false,
  digits = 2
) => {
  if (!players.length) {
    return asString ? "0.00" : 0;
  }
  const values = players.map((player) => parseNumber((player as any)[key]));
  const avg = values.reduce((sum, value) => sum + value, 0) / values.length;
  return asString ? formatDecimal(avg, digits) : Number(avg.toFixed(digits));
};

const buildAverageStatistics = (players: ReturnType<typeof buildPlayerStatistics>[]) => ({
  EventCountNLastDays: averageField(players, "EventCountNLastDays", false, 1),
  EventTotalTime: averageField(players, "EventTotalTimeInMinutes", false, 0),
  EventTotalTimeInMinutes: averageField(players, "EventTotalTimeInMinutes", false, 0),
  MaxSpeedNLastDays: averageField(players, "MaxSpeedNLastDays", true, 2),
  TotalDistance: averageField(players, "TotalDistance", false, 0),
  AverageDistance: averageField(players, "AverageDistance", false, 0),
  RunDistanceTotal: averageField(players, "RunDistanceTotal", false, 0),
  RunDistancePercentage: averageField(players, "RunDistancePercentage", true, 2),
  HSRDistanceTotal: averageField(players, "HSRDistanceTotal", false, 0),
  HSRDistancePercentage: averageField(players, "HSRDistancePercentage", true, 2),
  SprintDistanceTotal: averageField(players, "SprintDistanceTotal", false, 0),
  SprintDistancePercentage: averageField(players, "SprintDistancePercentage", true, 2),
  SprintNumberTotal: averageField(players, "SprintNumberTotal", false, 0),
  TimeToSprintInSeconds: averageField(players, "TimeToSprintInSeconds", true, 2),
  HMLDDistance: averageField(players, "HMLDDistance", false, 0),
  HMLDDistancePercentage: averageField(players, "HMLDDistancePercentage", true, 2),
  AccelerationNumberTotal: averageField(players, "AccelerationNumberTotal", false, 0),
  DecelerationNumberTotal: averageField(players, "DecelerationNumberTotal", false, 0),
  MaxPowerOutput: averageField(players, "MaxPowerOutput", true, 2),
  MaxHeartRate: averageField(players, "MaxHeartRate", false, 0),
  HeartRateLastNDaysAvg: averageField(players, "HeartRateLastNDaysAvg", false, 0),
  HeartRate1ZonePercentage: averageField(players, "HeartRate1ZonePercentage", false, 1),
  HeartRate2ZonePercentage: averageField(players, "HeartRate2ZonePercentage", false, 1),
  HeartRate3ZonePercentage: averageField(players, "HeartRate3ZonePercentage", false, 1),
  HeartRate4ZonePercentage: averageField(players, "HeartRate4ZonePercentage", false, 1),
  HeartRate5ZonePercentage: averageField(players, "HeartRate5ZonePercentage", false, 1),
  HRR: averageField(players, "HRR", false, 0),
  DynamicPercentage: averageField(players, "DynamicPercentage", false, 1),
  IntensityPercentage: averageField(players, "IntensityPercentage", false, 1),
  EndurancePercentage: averageField(players, "EndurancePercentage", false, 1),
  Form: averageField(players, "Form", false, 0),
  Readiness: averageField(players, "Readiness", false, 0),
  Potential: averageField(players, "Potential", false, 0),
  BurnCalories: averageField(players, "BurnCalories", false, 0),
  Load: averageField(players, "Load", false, 1),
});

const filterSeeds = (request: MonitoringRequest) => {
  const academyId = String(request.AcademyId ?? DEMO_ACADEMY_ID);
  const groupId =
    request.GroupId != null && request.GroupId !== "" ? String(request.GroupId) : null;

  return monitoringPlayerSeeds.filter((seed) => {
    if (seed.academyId !== academyId) {
      return false;
    }
    if (groupId && seed.groupId !== groupId) {
      return false;
    }
    return true;
  });
};

export const getMockMonitoringFolders = demoApi(async (academyId?: string) => {
  const folders =
    monitoringFoldersByAcademy[academyId ?? ""] ?? monitoringFoldersByAcademy[DEMO_ACADEMY_ID] ?? [];

  return {
    Data: folders.map((folder) => ({
      ...folder,
      ParentFolderId: "00000000-0000-0000-0000-000000000000",
    })),
  };
});
export const getMockAggregatedStatistics = demoApi(async (request: MonitoringRequest = {}) => {
  const microcycle = request.Microcycle ?? 4;
  const weekNumbers = Array.isArray(request.WeekNumbers) ? request.WeekNumbers : [];
  const { current, previous } = getMicrocycleScales(microcycle, weekNumbers);
  const levelsFactor = getLevelsFactor(request.Levels);
  const activity = request.Activity ?? 5;

  const seeds = filterSeeds(request);
  const playersStatistics = seeds.map((seed) => {
    const activityStats = applyActivityModifiers(seed.stats, activity);
    const scaledStats = scaleStats(activityStats, current * levelsFactor);
    return buildPlayerStatistics(seed, scaledStats, current * levelsFactor);
  });

  const playerConditions = seeds.map((seed, index) => ({
    PlayerId: seed.playerId,
    Form: playersStatistics[index]?.Form ?? seed.form,
    Readiness: playersStatistics[index]?.Readiness ?? seed.readiness,
    Potential: playersStatistics[index]?.Potential ?? seed.potential,
    CreatedAt: new Date(Date.now() - 2 * 24 * 60 * 60 * 1000).toISOString(),
  }));

  const trends = seeds.map((seed) => {
    const activityStats = applyActivityModifiers(seed.stats, activity);
    const previousStats = scaleStats(activityStats, previous * levelsFactor);
    return buildTrendEntry(seed, previousStats, previous * levelsFactor);
  });

  const timelineSummary = seeds.map((seed, index) => {
    const factor = seed.trendFactor ?? 1;
    const baseGoals = Math.max(0, Math.round((3 - index % 3) * factor));
    const baseYellow = index % 2 === 0 ? 1 : 0;
    return {
      playerId: seed.playerId,
      goals: activity === 2 ? 0 : baseGoals,
      penalties: activity === 2 ? 0 : index === 0 ? 1 : 0,
      yellowCards: activity === 2 ? 0 : baseYellow,
      redCards: activity === 2 ? 0 : index === 2 ? 1 : 0,
      timeOnField:
        activity === 2
          ? Math.round(70 + index * 5)
          : Math.round(75 + (seed.stats.EventTotalTimeInMinutes as number) / 10),
    };
  });

  return {
    StatusCode: 200,
    Data: {
      AverageStatistics: buildAverageStatistics(playersStatistics),
      PlayersStatistics: playersStatistics,
      PlayerConditions: playerConditions,
      Trends: trends,
      TimelineSummary: timelineSummary,
    },
  };
});
